import { render, staticRenderFns } from "./knowledges.vue?vue&type=template&id=7683c1c2"
import script from "./knowledges.vue?vue&type=script&lang=js"
export * from "./knowledges.vue?vue&type=script&lang=js"
import style0 from "./knowledges.vue?vue&type=style&index=0&id=7683c1c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports